export const loadCertificationData = async (certification, setCards, setSelectedCertification, setCurrentCardIndex, setShuffled, setIsLoading) => {
  setIsLoading(true);
  try {
    const module = await import(`../../data/${certification.dataFile}`);
    const flashcardsData = module.default;
    setCards(flashcardsData);
    setSelectedCertification(certification);
    setCurrentCardIndex(0);
    setShuffled(false);
  } catch (error) {
    console.error(`Error loading ${certification.name} data:`, error);
    setCards([]);
  } finally {
    setIsLoading(false);
  }
};
